export default {
  placeholder: 'Filter by Recipe',
};
